import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { NativeAd } from './components/native-ad';

export const MultiAdsStepShell = ({
  data,
  error,
  onDataChange,
}) => {
  const stepData = useMemo(() => (data || {}), [data]);

  const nativeAd = useMemo(() => (
    <NativeAd
      data={stepData}
      onDataChange={onDataChange}
      error={error}
      supportImageFitting
    />
  ), [error, onDataChange, stepData]);

  return (
    <>
      {nativeAd}
    </>
  );
};

MultiAdsStepShell.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
  error: PropTypes.shape({}).isRequired,
};
